import AppSettings from '../app-settings';
import { fetchUnauthed } from './fetch-with-token';

class InviteService {
  getInvite(token) {
    const inviteUrl = `${AppSettings.GRAPHQL_SERVER_URL}invite/${token}`;
    return fetchUnauthed(inviteUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  sendConfirmation(token) {
    const inviteUrl = `${AppSettings.GRAPHQL_SERVER_URL}invite/confirm/${token}`;
    return fetchUnauthed(inviteUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  getInviteConfirmation(token) {
    const inviteUrl = `${AppSettings.GRAPHQL_SERVER_URL}invite/extend/${token}`;
    return fetchUnauthed(inviteUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  acceptInvite(token, password, profile) {
    const inviteUrl = `${AppSettings.GRAPHQL_SERVER_URL}invite/accept`;
    const body = JSON.stringify({
      token,
      password,
      profile,
    });
    return fetchUnauthed(inviteUrl, {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

const inviteService = new InviteService();
export default inviteService;
